import classNames from 'classnames'
import PropTypes from 'prop-types'

import WavyHeading from '../WavyHeading/WavyHeading'

import './PageSection.scss'

export const PageSection = ({
  id = 'paths',
  className,
  title,
  description,
  smallTitle,
  smallTitleWaveColour,
  image,
  children,
}) => {
  return (
    <section id={id} className="page-section__container">
      <div className={classNames('page-section', className)}>
        {image && (
          <div className="page-section__image-wrapper">
            <img
              className="page-section__image"
              src={image.src}
              alt={image.alt}
            />
          </div>
        )}
        {title && (
          <h2
            className="page-section__title"
            dangerouslySetInnerHTML={{ __html: title }}
          />
        )}
        {description && (
          <div className="page-section__description">{description}</div>
        )}

        <div className="page-section__content">
          {smallTitle && (
            <WavyHeading text={smallTitle} waveColour={smallTitleWaveColour} />
          )}
          {children}
        </div>
      </div>
    </section>
  )
}

PageSection.propTypes = {
  id: PropTypes.string,
  title: PropTypes.string,
  description: PropTypes.string,
  smallTitle: PropTypes.string,
  smallTitleWaveColour: PropTypes.string,
  className: PropTypes.string,
  children: PropTypes.node,
  image: PropTypes.object,
}

export default PageSection
